import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import { DataService } from "./@core/services/data.service";
import { MenuItemModel, SiteDataModel } from "./@core/models/site-data.model";
import { Subscription } from "rxjs";
import { Title, Meta } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { ThemeService } from "./@core/services/theme.service";
import { ThemeModel } from "./@core/models/theme.model";
import { SiteModel } from "./@core/models/builder.model";
import { MatSidenav } from "@angular/material/sidenav";
import { SidenavService } from "./@core/services/sidenav.service";
import AOS from "aos";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class AppComponent implements OnInit, OnDestroy {
  siteData: SiteDataModel;
  siteTitle: string;
  siteModules: string[];
  siteTheme: ThemeModel;
  companyName: string;
  siteMenu: MenuItemModel[] = [];
  // subscription: Subscription;
  subscriptions: Subscription[] = [];
  @ViewChild("sidenav") public sidenav: MatSidenav;

  constructor(
    private dataService: DataService,
    private titleService: Title,
    private metaService: Meta,
    private router: Router,
    private route: ActivatedRoute,
    private themeService: ThemeService,
    private sidenavService: SidenavService
  ) {
  }

  ngOnInit(): void {
    AOS.init({
      offset: 250,
      delay: 0,
      duration: 1800,
      once: true
    });
    this.route.fragment.subscribe((fragment: string) => {
      if (fragment && document.getElementById(fragment) != null) {
        setTimeout(() => {
          document
            .getElementById(fragment)
            .scrollIntoView({ behavior: "smooth" }); // , block: 'center', inline: 'center' });
        });
      }
    });

    const subscription2 = this.dataService
      .getCurrentSite()
      .subscribe(async (site: SiteModel) => {
        // this.dataService.setSite(site);
        // Making sure data is loaded
        if (site !== null) {
          this.siteTitle = site.siteName;
          // this.companyName = site.companyName;
          this.siteModules = site.modules;
          this.siteData =
            typeof site.siteData == "string"
              ? JSON.parse(site.siteData)
              : site.siteData;
          this.siteTheme =
            typeof site.siteStyle == "string"
              ? JSON.parse(site.siteStyle)
              : site.siteStyle;

          // change the site title
          if (
            this.titleService
              .getTitle()
              .toLocaleLowerCase()
              .includes("sitecreator.io")
          ) {
            this.titleService.setTitle(this.siteTitle);
          }

          if (site.description) {
            this.metaService.updateTag({
              name: "description",
              content: site.description,
            });
          }
          this.themeService.updateTheme(this.siteTheme);

          // Get menu links
          if (site.siteMenu) {
            this.siteMenu = site.siteMenu;
          } else {
            this.getMenu();
          }
        }
      });
  }

  getMenu(): void {
    this.siteMenu = [];
  }

  navigate(link: string, option: string): void {
    if (option) {
      window.open(link, option);
    } else {
      this.router.navigate(["/"], { fragment: link });
    }
  }

  navigateTo(fragment: string) {
    if (fragment) {
      fragment = fragment.replace("/#", "");
      setTimeout(() => {
        if (document.getElementById(fragment)) {
          document
            .getElementById(fragment)
            .scrollIntoView({ behavior: "smooth" });
        }
      });
    }
  }
  // tslint:disable-next-line:use-lifecycle-interface
  ngAfterViewInit(): void {
    this.sidenavService.setSidenav(this.sidenav);
  }

  ngOnDestroy(): void {
    // this.subscription.unsubscribe();
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
